import { TTypeOfModalWindow, IInitialFormData } from './editFirmwareContext';
import { IFileData, ICreateUpdateFirmware, TFirmwareType } from 'types';

export enum EditFirmwareActionTypes {
	REFETCH_DATA = 'REFETCH_DATA',
	SET_INITIAL_FORM_DATA = 'SET_INITIAL_FORM_DATA',
	SET_ALL_DATA = 'SET_ALL_DATA',
	SET_TYPE_SELECTED_FIRMWARE = 'SET_TYPE_SELECTED_FIRMWARE',
	CHANGE_NAME_OF_FIRMWARE = 'CHANGE_NAME_OF_FIRMWARE',
	CHANGE_VERSION_OF_FIRMWARE = 'CHANGE_VERSION_OF_FIRMWARE',
	CHANGE_DESCRIPTION = 'CHANGE_DESCRIPTION',
	CHANGE_FILE_DATA = 'CHANGE_FILE_DATA',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	RESET_FIELDS = 'RESET_FIELDS',
}

interface IRefetchData {
	type: EditFirmwareActionTypes.REFETCH_DATA;
	payload: {
		needRefetch: boolean;
	};
}

interface ISetInitialFormData {
	type: EditFirmwareActionTypes.SET_INITIAL_FORM_DATA;
	payload: {
		initialFormData: IInitialFormData;
	};
}

interface ISetAllData {
	type: EditFirmwareActionTypes.SET_ALL_DATA;
	payload: {
		id: string;
		typeSelectedFirmware: TFirmwareType;
		nameOfFirmware: string;
		versionOfFirmware: string;
		description: string;
		fileData: IFileData;
	};
}

interface ISetTypeSelectedFirmware {
	type: EditFirmwareActionTypes.SET_TYPE_SELECTED_FIRMWARE;
	payload: {
		typeSelectedFirmware: TFirmwareType;
	};
}

interface IChangeNameOfFirmware {
	type: EditFirmwareActionTypes.CHANGE_NAME_OF_FIRMWARE;
	payload: {
		nameOfFirmware: string;
	};
}

interface IChangeVersionOfFirmware {
	type: EditFirmwareActionTypes.CHANGE_VERSION_OF_FIRMWARE;
	payload: {
		versionOfFirmware: string;
	};
}

interface IChangeDescription {
	type: EditFirmwareActionTypes.CHANGE_DESCRIPTION;
	payload: {
		description: string;
	};
}

interface IChangeFileHash {
	type: EditFirmwareActionTypes.CHANGE_FILE_DATA;
	payload: {
		fileData: IFileData;
	};
}

interface ISetDataForSubmit {
	type: EditFirmwareActionTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		dataForSubmit: ICreateUpdateFirmware | null;
	};
}

interface IChangeTypeOfModalWindow {
	type: EditFirmwareActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: TTypeOfModalWindow;
	};
}

interface IResetSelectedControls {
	type: EditFirmwareActionTypes.RESET_FIELDS;
}

export type TEditFirmwareAction =
	| IRefetchData
	| ISetInitialFormData
	| ISetAllData
	| ISetTypeSelectedFirmware
	| IChangeNameOfFirmware
	| IChangeVersionOfFirmware
	| IChangeDescription
	| IChangeFileHash
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow
	| IResetSelectedControls;
